/**
 * Convert stored dates to/from yyyy-MM-dd for form controls and API payloads.
 * Uses UTC calendar components for ISO timestamps to avoid off-by-one day shifts.
 */

export function formatDateForInput(dateString: string | undefined | null): string {
    if (!dateString) return '';

    try {
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            return dateString;
        }

        const date = new Date(dateString);
        if (Number.isNaN(date.getTime())) {
            return '';
        }

        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    } catch {
        return '';
    }
}

export function formatDateForAPI(dateString: string | undefined | null): string {
    if (!dateString) return '';

    if (dateString.includes('T') || dateString.includes('Z')) {
        return dateString;
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        const [year, month, day] = dateString.split('-').map(Number);
        const date = new Date(Date.UTC(year!, month! - 1, day!, 0, 0, 0, 0));
        return date.toISOString();
    }

    return dateString;
}

/** Local noon ISO from yyyy-MM-dd — matches CRM follow-up / est. close pattern. */
export function ymdToLocalNoonIso(ymd: string): string | null {
    const s = String(ymd || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
    const d = new Date(`${s}T12:00:00`);
    if (Number.isNaN(d.getTime())) return null;
    return d.toISOString();
}

/** Local yyyy-MM-dd from ISO (uses local calendar day). */
export function isoToLocalYmd(iso: string | Date | null | undefined): string {
    if (iso == null || iso === '') return '';
    const d = iso instanceof Date ? iso : new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
